import { DataSource, Image, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutEdiInboundLogQuickInfoTable extends Layout {
    imagePopOut: Image;
    labelInboundLogHistory: Label;
    sourceEdiLog: DataSource;
    tableInboundLogHistory: Table;
}
